import { makeObservable, override } from 'mobx';
import {
    LoanApplicationApiFindAllApplicationsRequest,
    LoanApplicationDto,
    LoanApplicationDtoBrief,
} from 'src/generated-api-client';
import {
    bpmsResourcesManagerApi,
    loanApplicationsApi,
} from 'src/services/apiServices';
import { ListFilter } from 'src/utils/FormHelper';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { FilterCriteria } from 'src/utils/mobx/FilterCriteria';
import { Pager } from 'src/utils/mobx/Pager';
import { Sorter } from 'src/utils/mobx/Sorter';
import { RequestHelper } from 'src/utils/RequestHelper';

export type LoanApplicationFilters =
    ListFilter<LoanApplicationApiFindAllApplicationsRequest>;

export class LoanApplicationsStoreClass extends BasicStore<
    LoanApplicationDtoBrief,
    LoanApplicationFilters,
    unknown,
    unknown,
    LoanApplicationDto
> {
    constructor() {
        super();
        makeObservable(this);
    }

    itemPathKey = 'loanApplicationId';
    itemDetailsFormKey =
        'embedded:deployment:forms/bo/bo-02-loan-application-info.json';

    pager = new Pager();
    sorter = new Sorter();
    filterCriteria = new FilterCriteria<LoanApplicationFilters>();

    api: BasicStoreApi<
        LoanApplicationDtoBrief,
        unknown,
        unknown,
        LoanApplicationDto
    > = {
        loadList: async (...args: any[]) => {
            const options = RequestHelper.getOptionsFromArgs(args);
            const response = await RequestHelper.unwrapFromAxiosPromise(
                loanApplicationsApi.findAllApplications(
                    {
                        ...this.pager,
                        ...this.sorter,
                        ...this.filterCriteria.filter,
                    },
                    options,
                ),
            );

            this.pager.setTotal(response.totalElements || 0);

            return response.content || [];
        },
        loadItem: (id, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                loanApplicationsApi.getApplication({ id }, options),
            );
        },
        loadItemForm: (...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                bpmsResourcesManagerApi.getForm(
                    { formKey: this.itemDetailsFormKey },
                    options,
                ),
            );
        },
    };

    @override get hasFilter() {
        return (
            Boolean(this.filterCriteria.filter.filterStatuses) ||
            (Boolean(this.filterCriteria.filter.filterRequestedAtFrom) &&
                Boolean(this.filterCriteria.filter.filterRequestedAtTo)) ||
            Boolean(this.filterCriteria.filter.filterSearch)
        );
    }
}

export const LoanApplicationsStore = new LoanApplicationsStoreClass();
